import TermsAndConditions from '../containers/TermsAndConditions/TermsAndConditions';
import reducerMap from '../ducks';

function onLoad(module, info, props, context) {
    context.store.inject({
        ...reducerMap,
    });
}

export { onLoad };
export default TermsAndConditions;
